export default {
	title: 'sensor_settings',
	components: [
		{
			title: 'temperature_offset',
			component: 'temperature_offset_g2',
			min_ver: '0.11.4',
		},
		{ title: 'temperature_threshold', component: 'temperature_threshold_g2' },
		{
			title: 'humidity_offset',
			component: 'humidity_offset_g2',
			min_ver: '0.11.4',
		},
		{ title: 'humidity_threshold', component: 'humidity_threshold_g2' },
		{ title: 'dark_threshold', component: 'dark_threshold_g2' },
		{ title: 'bright_threshold', component: 'bright_threshold_g2' },
	],
};
